import React from "react";
import { Card } from "../card";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import {
  setClassId,
  setFirstName,
  setLastName,
  setMiddleName,
  setMobile,
  setSchoolBranchId,
  setSubjects,
  setAddress,
  setGender,
  setJobType,
  setBaseSalary,
  setEmail,
  setPassword,
  setSchoolBlockId,
  reset,
} from "../../Redux/Slices/registerTeachers.slice";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";

import { JobType } from "../../Constants/Enums/teachers.enum";
import {
  TEACHERS_KEYS,
  useRegisterTeacher,
} from "../../hooks/teacherHooks/teacher.hooks";
import { SOMETHING_WENT_WRONG } from "../../Constants/messages";
import { TeachersForm } from "./TeachersForm";
import queryClient from "../../config/queryClient";

export const TeachersRegistration = () => {
  const dispatch = useDispatch();
  // const { isLoading: isSchoolBrachesLoading, data: BRANCHES_OPTIONS } =
  //   useGetSchoolBranchesOptions();
  // const { isLoading: isClassesLoading, data: CLASSES_OPTIONS } =
  //   useGetClassesOptions();
  // const { isLoading: isBlocksLoading, data: BLOCKS_OPTIONS } =
  //   useGetSchoolBlocksOptions();

  const {
    firstName,
    middleName,
    lastName,
    gender,
    email,
    address,
    mobile,
    password,
    schoolBranchId,
    schoolBlockId,
    classId,
    subjects,
    jobType,
    baseSalary,
  } = useSelector((state: RootState) => ({
    firstName: state.registerTeacher.firstName,
    middleName: state.registerTeacher.middleName,
    lastName: state.registerTeacher.lastName,
    gender: state.registerTeacher.gender,
    email: state.registerTeacher.email,
    address: state.registerTeacher.address,
    mobile: state.registerTeacher.mobile,
    password: state.registerTeacher.password,
    schoolBranchId: state.registerTeacher.schoolBranchId,
    schoolBlockId: state.registerTeacher.schoolBlockId,
    classId: state.registerTeacher.classId,
    subjects: state.registerTeacher.subjects,
    jobType: state.registerTeacher.jobType,
    baseSalary: state.registerTeacher.baseSalary,
  }));

  const { isLoading: isRegisteringTeacher, mutate: registerTeacher } =
    useRegisterTeacher();

  const handleTeacherRegistration = () => {
    const subjectIds = (subjects || []).map(({ value }) => value);
    registerTeacher(
      {
        firstName,
        middleName,
        lastName,
        email,
        password,
        mobile,
        address,
        baseSalary,
        jobType,
        schoolBranchId,
        schoolBlockId,
        subjectIds,
        classId,
      },
      {
        onSuccess: () => {
          dispatch(
            setSuccessMessage("Teacher has been registered successfully.")
          );
          dispatch(reset());
          queryClient.invalidateQueries({
            queryKey: [TEACHERS_KEYS.TEACHERS_LIST],
          });
        },

        onError: (error: any) => {
          dispatch(
            setErrorMessage(error.response.data.message || SOMETHING_WENT_WRONG)
          );
        },
      }
    );
  };
  return (
    <Card
      cardTitle="Register new teacher"
      cardSubTitle="Fill out the form to onboard a new teacher in the system."
    >
      <>
        <TeachersForm
          firstName={firstName}
          middleName={middleName}
          lastName={lastName}
          email={email}
          password={password}
          mobile={mobile}
          address={address}
          gender={gender}
          classId={classId as number}
          schoolBlockId={schoolBlockId as number}
          schoolBranchId={schoolBranchId as number}
          subjects={subjects}
          jobType={jobType}
          baseSalary={baseSalary as string | null}
          onSetFirstName={(firstName: string) => {
            dispatch(setFirstName(firstName));
          }}
          onSetMiddleName={(middleName: string) => {
            dispatch(setMiddleName(middleName));
          }}
          onSetLastName={(lastName: string) => {
            dispatch(setLastName(lastName));
          }}
          onSetEmail={(email: string) => {
            dispatch(setEmail(email));
          }}
          onSetPassword={(password: string) => {
            dispatch(setPassword(password));
          }}
          onSetMobile={(mobile: string) => {
            dispatch(setMobile(mobile));
          }}
          onSetAddress={(address: string) => {
            dispatch(setAddress(address));
          }}
          onSetGender={(gender: string) => {
            dispatch(setGender(gender));
          }}
          onSetJobType={(jobType: JobType) => {
            dispatch(setJobType(jobType));
          }}
          onSetBaseSalary={(baseSalary: string | number) => {
            dispatch(setBaseSalary(baseSalary as string));
          }}
          onSetSubjects={(subjects: []) => {
            dispatch(setSubjects(subjects));
          }}
          onSetSchoolBlockId={(blockId: number) => {
            dispatch(setSchoolBlockId(blockId));
          }}
          onSetSchoolBranchId={(branchId: number) => {
            dispatch(setSchoolBranchId(branchId));
          }}
          onSetClassId={(classId: number) => {
            dispatch(setClassId(classId));
          }}
          onReset={() => {
            dispatch(reset());
          }}
          onSubmit={() => {
            handleTeacherRegistration();
          }}
          isSubmitting={isRegisteringTeacher}
        />
      </>
    </Card>
  );
};
